import * as Objdict from "objdict"

// const shapes = {
//     "block": {"size": 1},
//     "south-ramp": {"size": 0.5},
//     "east-ramp": {"size": 0.5},
// }

// ALWAYS ASSUMES LAYERS ARE LOWERCASE
// ALWAYS ASSUMES THE TILESET IS COLLECTION OF IMAGES
// ALWAYS ASSUMES JSON NOT TMX
// ALWAYS ASSUMES ALL IMAGES ARE IN THE SAME DIRECTORY AS THE TILESET.

const FIRST_TILEGID = 1

// these are preloaded with the tileset. Just animating them here.
const TILE_ANIMATIONS = {
    93: {
        "isLoop": true,
        "frames": [
            {
                "time": 0,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/18_upper-left-tv-1of2.png").default,
            },
            {
                "time": 100,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/22_upper-left-tv-2of2.png").default,
            },
            {
                "time": 200,
            },
        ]
    },
    94: {
        "isLoop": true,
        "frames": [
            {
                "time": 0,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/19_upper-right-tv-1of2.png").default,
            },
            {
                "time": 100,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/23_upper-right-tv-2of2.png").default,
            },
            {
                "time": 200,
            },
        ]
    },
    95: {
        "isLoop": true,
        "frames": [
            {
                "time": 0,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/20_lower-left-tv-1of2.png").default,
            },
            {
                "time": 100,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/24_lower-left-tv-2of2.png").default,
            },
            {
                "time": 200,
            },
        ]
    },
    96: {
        "isLoop": true,
        "frames": [
            {
                "time": 0,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/21_lower-right-tv-1of2.png").default,
            },
            {
                "time": 100,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/25_lower-right-tv-2of2.png").default,
            },
            {
                "time": 200,
            },
        ]
    },
    90: {
        "isLoop": true,
        "frames": [
            {
                "time": 0,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/15_dash-1of3.png").default,
            },
            {
                "time": 100,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/16_dash-2of3.png").default,
            },
            {
                "time": 200,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/17_dash-3of3.png").default,
            },
            {
                "time": 300,
                "image": require("@frog/source/assets/images/bomber-tactics/tiles/tiles-lowrezjam/15_dash-1of3.png").default,
            },
        ]
    },
}

TILE_ANIMATIONS[91] = TILE_ANIMATIONS[90]
TILE_ANIMATIONS[92] = TILE_ANIMATIONS[90]

export default class Tiled {
    static parse({tilemap, tileset}) {
        if(tilemap == undefined) {
            return undefined
        }

        if(tilemap["compressionlevel"] != -1) {
            return console.error("Tiled.parse does not yet support this compression level:", tilemap)
        }
        if(tilemap.tilesets.length != 1) {
            return console.error("Tiled.parse does not yet support multile tilesets:", tilemap)
        }

        const world = {
            "width": tilemap.width,
            "height": tilemap.height,

            "blocks": {},
            "terrain": {},
            "unitspawns": {},
            // "collision": {},
            // "edges": {},
        }

        world.tileset = {
            "tiles": Objdict.convert(tileset.tiles.map((tile) => {
                return {
                    "key": tile.id,
                    "id": tile.id,
                    "animation": TILE_ANIMATIONS[tile.id],
                    "imageWidth": tile.imagewidth,
                    "imageHeight": tile.imageheight,
                    "imageSource": require("@frog/source/assets/images/bomber-tactics/tiles/" + (tile.image.replace(".png", "")) + ".png").default,
                    "properties": tile.properties,
                    "hasCollision": tile.properties && !!tile.properties.find((property) => property.name == "hasCollision" && property.value == true),
                    "hasBoost": tile.properties && !!tile.properties.find((property) => property.name == "hasBoost" && property.value == true),
                    "hasSafezone": tile.properties && !!tile.properties.find((property) => property.name == "hasSafezone" && property.value == true),
                }
            }))
        }

        tilemap.layers.forEach((layer) => {
            layer.z = Tiled.findPropertyValue(layer.properties, "z") || 0

            if(layer.name == "data:units"
            && layer.type == "objectgroup"
            && layer.visible == true) {
                return layer.objects.forEach((object) => {
                    if(object.visible == false) return
                    if(isNaN(object.gid)) return // this filters out anything that isn't an image stamp.

                    object.key = Tiled.findPropertyValue(object.properties, "Key")

                    object.gid -= FIRST_TILEGID
                    object.tile = world.tileset.tiles[object.gid]
                    if(object.tile == undefined) {
                        return console.error("Tiled.parse could not find this tile gid:", object)
                    }

                    object.type = object.type || Tiled.findPropertyValue(object.properties, "UnitType")
                    object.type = object.type || object.tile.type
                    object.type = object.type || Tiled.findPropertyValue(object.tile.properties, "DefaultUnitType")
                    object.type = object.type || Tiled.findPropertyValue(object.tile.properties, "UnitReference")

                    if(object.type == undefined || object.type == "") {
                        return console.error("Tiled.parse could not find object type:", object)
                    }

                    const unit = {
                        "key": object.key || object.id,
                        "reference": object.type,
                        "position": {
                            "x": Math.floor(object.x / tilemap.tilewidth),
                            "y": Math.floor(object.y / tilemap.tileheight) - 1,
                            "z": layer.z
                        }
                    }
                    world.unitspawns[unit.key] = unit
                })
            }

            // if(layer.name == "data:collision"
            // && layer.type == "tilelayer") {
            //     return Tiled.iterateTileLayer(layer, ({tilegid, position}) => {
            //         tilegid -= FIRST_TILEGID
            //         if(tilegid > -1) {
            //             world.tiles[position.key] = world.tiles[position.key] || {}
            //             world.tiles[position.key].position = world.tiles[position.key].position || position
            //             world.tiles[position.key].collision = true
            //         }
            //     })
            // }

            if(layer.type == "tilelayer"
            && layer.visible == true) {
                Tiled.iterateTileLayer(layer, ({position, tilegid}) => {
                    tilegid -= FIRST_TILEGID
                    const tile = world.tileset.tiles[tilegid]
                    if(tile == undefined) return

                    position.z = layer.z
                    position.xy = position.x + "x" + position.y
                    position.xyz = position.xy + "x" + position.z

                    world.blocks[position.xyz] = world.blocks[position.xyz] || {}
                    world.blocks[position.xyz].position = world.blocks[position.xyz].position || position

                    world.blocks[position.xyz].image = tile.imageSource
                    world.blocks[position.xyz].animation = tile.animation

                    world.terrain[position.xy] = world.terrain[position.xy] || {
                        "position": {"x": position.x, "y": position.y, "z": 0},
                        "size": {"x": 1, "y": 1, "z": 0},
                    }
                    if(world.terrain[position.xy].size.z < layer.z + 1) {
                        world.terrain[position.xy].size.z = layer.z + 1
                    }
                    if(tile.hasCollision == true) {
                        world.terrain[position.xy].hasCollision = true
                    }
                    if(tile.hasBoost == true) {
                        world.terrain[position.xy].hasBoost = true
                    }
                    if(tile.hasSafezone == true) {
                        world.terrain[position.xy].hasSafezone = true
                    }
                })
            }
        })

        // layers.forEach((layer, layerName) => {
        //     const type = layer.type
        //     const zlayer = layer?.properties?.find(element => element.name == "zlayer")?.value ?? 0
        //     const isCollisionLayer = (layer?.properties?.find(element => element.name == "collision")?.value ?? false) === true
        //     const isUnitsLayer = (layer?.properties?.find(element => element.name == "units")?.value ?? false) === true
        //
        //     if(type == "tilelayer") {
        //         layer.data.forEach((value, index) => {
        //             const x = index % protoworld.width
        //             const y = Math.floor(index / protoworld.width)
        //             const z = Number.parseInt(zlayer)
        //             if(isCollisionLayer) {
        //                 if(value != 0) {
        //                     world.collision[x + "x" + y] = world.collision[x + "x" + y] || {}
        //                     world.collision[x + "x" + y].hasCollision = true
        //                 }
        //             } else if(isUnitsLayer) {
        //                 if(value != 0) {
        //                     world.unitspawns[x + "x" + y] = world.unitspawns[x + "x" + y] || {}
        //                     world.unitspawns[x + "x" + y] = {"tilesetGID": value, "position": {x, y, z}}
        //                 }
        //             } else {
        //                 if(value != 0) {
        //                     world.display[z] = world.display[z] || {}
        //                     world.display[z][x + "x" + y] = {
        //                         "position": {x, y, z},
        //                         "tilesetGID": value,
        //                     }
        //                 }
        //             }
        //         })
        //     }
        // })

        // // console.log(protoworld)
        //
        // // for(let x = 0; x < protoworld.width; x += 1) {
        // //     for(let y = 0; y < protoworld.height; y += 1) {
        // //         const tileKey = x + "x" + y
        // //         protoworld.terrain[tileKey] = protoworld.terrain[tileKey] || {
        // //             "position": {"x": x, "y": y, "z": 0},
        // //             "size": { "x": 1, "y": 1, "z": 0 },
        // //         }
        // //     }
        // // }
        //
        // Objdict.forEach(protoworld.display, (layer, layerIndex) => {
        //     Objdict.forEach(layer, (tile, tileKey) => {
        //         const tilesetId = tile.tilesetGID - tileset.firstgid
        //         const tilesetTile = tileset.source.tiles[tilesetId]
        //         tile.image = tilesetTile.image
        //
        //         if(tilesetTile.sequentialId >= firstDayTile && tilesetTile.sequentialId < firstNightTile) {
        //             const nightTileSequentialId = firstNightTile + (tilesetTile.sequentialId - firstDayTile)
        //             Objdict.forEach(tileset.source.tiles, nightTile => {
        //                 if(nightTile.sequentialId == nightTileSequentialId) {
        //                     tile.nightImage = nightTile.image
        //                 }
        //             })
        //         }
        //
        //         const x = tile.position.x
        //         const y = tile.position.y
        //         protoworld.terrain[tileKey] = protoworld.terrain[tileKey] || {
        //             "position": {"x": x, "y": y, "z": 0},
        //             "size": { "x": 1, "y": 1, "z": 0 },
        //         }
        //         const terrainData = protoworld.terrain[tileKey]
        //
        //         const zindex = parseInt(layerIndex)
        //         // If the highest terrain block is a
        //         // ramp, it should be considered a half-block.
        //         if(terrainData.size.z < zindex + 1) {
        //             const shape = tilesetTile.shape || "block"
        //             const shapeData = shapes[shape]
        //             const tileIsCollidable = tilesetTile.hasCollision === undefined ? true : tilesetTile.hasCollision
        //             const isWalkable = tilesetTile.walkable === undefined ? true : tilesetTile.walkable
        //             const hasCollision = protoworld.collision[tileKey] != undefined
        //
        //             // terrainData.shape = shape
        //             terrainData.hasCollision = hasCollision // !isWalkable ||
        //
        //             // terrainData.isPath = tilesetTile.isPath
        //             // terrainData.isTree = tilesetTile.isTree
        //
        //             if(tileIsCollidable === false) {
        //                 // Ignore the shape, don't add any height
        //                 terrainData.size.z = zindex
        //             } else if(shapeData != undefined) {
        //                 // Use the shape to determine the tile's height
        //                 terrainData.size.z = zindex + shapeData.size
        //             } else {
        //                 // Assume block
        //                 terrainData.size.z = zindex + 1
        //             }
        //         }
        // //         protoworld.terrain[tileKey] = protoworld.terrain[tileKey] || {
        // //             "position": {"x": x, "y": y, "z": 0},
        // //             "size": { "x": 1, "y": 1, "z": 0 },
        // //         }
        //
        //         protoworld.terrain[tileKey] = terrainData
        //     })
        // })

        return world
    }
    static iterateTileLayer(layer, func) {
        layer.data.forEach((tilegid, index) => {
            const position = {}
            position.x = index % layer.width
            position.y = Math.floor(index / layer.width)
            func({position, tilegid, index})
        })
    }
    static findPropertyValue(properties, name) {
        if(properties == undefined) return
        const property = properties.find((property) => {
            if(property == undefined) return false
            if(property.name == undefined) return false
            if(property.name.toLowerCase() == name.toLowerCase()) return true
        })
        if(property != undefined) {
            return property.value
        }
    }
}
